import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import btnArrow from "../assets/img/section-btn-arrow.webp";
import alterationIconTwo from "../assets/img/alteration-icon-2.webp";
import alterationIconOne from "../assets/img/alteration-icon-1.webp";
import washIcon from "../assets/img/wash-icon.webp";
import chainstitchIcon from "../assets/img/chainstitch-icon.svg";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import useCartStore from "../api/cart";
import CartSummary from "./CartSummary";
import { addedPrices, repricePairs } from "../utils/cartSummary";
import { isJeans } from "../utils/jeansScreen";
import {
  MAX_PLACEMENT,
  POCKET_OR_SEAM,
  chainstitchFields,
  pickableServices,
  placementDetails,
  placementError,
} from "../utils/chainstitch";
import {
  KIND_FOR_TASK,
  lockedReason,
  pairSiblings,
  orderServices,
  repeatsOnOnePiece,
  serviceKind,
  shortServiceName,
  TASK_FOR_KIND,
} from "../utils/serviceOptions";

const pathURL = process.env.REACT_APP_API_URL;

function Alteration() {
  const location = useLocation();
  const selectedType = location?.state?.selectedItem
    ? location?.state?.selectedItem?.name
    : sessionStorage.getItem("selectedItem");
  const { cartItems, updateCartItem } = useCartStore();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const fetchCode = async () => {
    const { data } = await axios.post(`${pathURL}service/getservicebyitem`, {
      text: location?.state?.selectedItem?.name.trim() || selectedType?.trim(),
      // This is the counter. Services marked `studio_only` — the chainstitch
      // lines — are hidden by default so the online store cannot sell work
      // that needs the garment in the building, and are asked for here.
      // See fxrybackend/controllers/service.js.
      studio: true,
    });
    return data;
  };
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["fetchService"],
    queryFn: fetchCode,
  });

  const [selectedPricingPlan, setselectedPricingPlan] = useState("");

  const [isOpen, setIsOpen] = useState(true);
  const [isOpen1, setIsOpen1] = useState(true);

  const toggleBox = () => {
    setIsOpen(!isOpen);
    setIsOpen1(!isOpen1);
  };

  const [selectedPlan] = useState(() => {
    const savedPlan = sessionStorage.getItem("selectedPlan");
    return savedPlan || "";
  });

  const [selectedTask, setSelectedTask] = useState(() => {
    const savedTask = sessionStorage.getItem("task");
    return savedTask || "";
  });
  const [pinVideo, setPinVideo] = useState();
  const [selectedOption, setSelectedOption] = useState(() => {
    const savedOption = sessionStorage.getItem("option");
    return savedOption || "";
  });

  const [selectedOptionPrice, setSelectedOptionPrice] = useState(() => {
    const savedOption = sessionStorage.getItem("optionprice");
    return savedOption || "";
  });

  // How many of the picked service go on this piece. Buttons, snaps and
  // holes come in twos and threes, and each one used to be a whole trip back
  // through this screen (Calley, 24 Oct 2026: "can you make it so we can add
  // multiple buttons to one item, like add or replace multi at once").
  // One row per unit still goes on the bill, so the count is on the receipt
  // and nobody has to read "replace buttons" and guess how many.
  const [howMany, setHowMany] = useState(1);
  const MOST = 20;

  const handleTaskSelection = (task) => {
    // A pair of jeans goes to its own repair screen (components/JeansScreen
    // .jsx): every hole in one pass, each with its own size and its own place.
    // Jeans arrive with holes of two and three different sizes, and each size
    // used to be a whole trip back through this screen. Alterations stay here:
    // they are most of what jeans need, and in the 12 months to 25 Oct 2026
    // only 1 pair in 25 with mixed hole sizes also needed one.
    if (task === "Repairing" && isJeans(selectedType)) {
      navigate("/jeans", { state: location?.state });
      return;
    }
    // Moving to another category drops whatever was picked under the old one.
    // The list below already redraws to the new category, but the pick used
    // to survive it: tap Repair, choose FIX STITCHING, then tap Chainstitch,
    // and the $25 repair saved itself under Chainstitch with Add still lit
    // and nothing in the visible list chosen. A real order came in that way
    // on 30 Oct 2026 (pants, "fix stitching on seam at crotch"). The category
    // decides the Category line, which questions the next screen asks, the
    // reports, and whether the QR page wants before and after photos, so a
    // line filed under the wrong one is wrong everywhere at once, and nothing
    // on this screen said so.
    //
    // Tapping the category already on is not a move, so it clears nothing.
    if (task === selectedTask) return;
    setSelectedTask(task);
    setSelectedOption(null);
    setservices([]);
    setSelectedOptionPrice("");
    setPinVideo();
    setHowMany(1);
    // The write-in goes too. Its price and its wording were typed for the old
    // category, and "Custom repair" and "Custom chainstitch" are not the same
    // line.
    setCustomDescription("");
    setCustomPrice("");
    setCustomMinutes("");
    setPlacement("");
    setOpenIt(false);
  };

  const [services, setservices] = useState([]);
  // Chainstitch asks two things here, with the garment in hand: where it
  // goes, and whether we have to open the garment up to reach it. The second
  // follows from the first, and it is the one that costs $30.
  const [placement, setPlacement] = useState("");
  const [openIt, setOpenIt] = useState(false);
  const [stitchError, setStitchError] = useState(null);

  const handleOptionSelection = (item, data) => {
    setHowMany(1);
    if (services && selectedOption === item?.name) {
      setSelectedOption(null);
      setservices([]);
      setSelectedOptionPrice("");
      setPinVideo();
    } else {
      setPlacement("");
      setOpenIt(false);
      setStitchError(null);
      setSelectedOption(item?.name);
      setSelectedOptionPrice(
        sessionStorage.getItem("SelectedPlan") == "Premium" ||
          location?.state?.selectedItem?.pricing_plan == "Premium"
          ? item?.premium_price
          : item?.standard_price,
      );
      setservices([data]);
      setPinVideo(item.pin_item_video);
    }
  };

  // Off-menu write-in: customer types a description + price when the
  // request doesn't match a preset Repair/Alteration line. Flagged
  // is_custom so superadmin/reporting can tell it apart from a catalog
  // pick; it still flows through as a real job (fixer, date fixed, time
  // taken all work normally on it) and shows on the receipt like any
  // other line.
  const [customDescription, setCustomDescription] = useState("");
  const [customPrice, setCustomPrice] = useState("");
  // Our guess at the sewing time, for us only: never on the receipt or any
  // customer email. Studio load plans the day with it, and Price history
  // can set it against the time actually logged (Calley, 2026-10-16).
  const [customMinutes, setCustomMinutes] = useState("");

  const handleCustomSubmit = () => {
    const desc = customDescription.trim();
    const price = parseFloat(customPrice);
    if (!desc || isNaN(price) || price <= 0) {
      return;
    }
    const minutes = Math.round(parseFloat(customMinutes));
    const customItem = {
      id: `custom-${Date.now()}`,
      name: desc,
      standard_price: price,
      premium_price: price,
      service_type: selectedTask === "Alteration",
      // Derived, not a ternary on "Alteration": that filed a custom wash as a
      // repair, and would have done the same to a custom chainstitch.
      service_kind: KIND_FOR_TASK[selectedTask] || "repair",
      is_standard: true,
      is_premium: true,
      pin_item_video: null,
      is_custom: true,
      // What staff typed is the reason for the custom price, so checkout
      // doesn't stop to ask "why this price?" while the customer waits.
      override_reason: desc,
      ...(minutes > 0 ? { estimated_minutes: minutes } : {}),
    };
    setHowMany(1);
    setSelectedOption(customItem.name);
    setSelectedOptionPrice(price);
    setservices([customItem]);
    setPinVideo(null);
  };

  // Only the handful of services a garment really carries more than one of
  // get a count (utils/serviceOptions.js). A hem, a reline or a zipper is one
  // to a garment, and a stepper on those is a question nobody at the counter
  // needs asked.
  //
  // A write-in is left out too: staff put the number in the words there
  // ("replace 2 missing buttons") and type one price for the lot, so counting
  // it up again would multiply a price that already covers them all.
  const pickedService = services?.[0];
  const canRepeat = Boolean(
    selectedOption &&
    !pickedService?.is_custom &&
    repeatsOnOnePiece(selectedOption),
  );
  // What actually gets added. Picking a different service already puts the
  // count back to 1, so this only matters if that ever stops being true.
  const countToAdd = canRepeat ? Math.max(1, howMany) : 1;

  // Which boxes chainstitch wants on this screen. Null for every other kind
  // of work, and null for a custom write-in, which is quoted by hand.
  const stitchFields = pickedService?.is_custom
    ? null
    : chainstitchFields(selectedOption);
  // The $30 line itself, straight off the same catalogue the picker reads.
  // Never a typed price (utils/chainstitch.js).
  const pocketLine = (data || []).find(
    (service) => service?.name === POCKET_OR_SEAM,
  );

  const navigate = useNavigate();

  const handleApply = () => {
    const storedTask = sessionStorage.getItem("task");
    const storedOption = sessionStorage.getItem("option");

    // Anything stitched has to say where it goes before the garment leaves
    // the counter, because that is also when the pin goes in.
    const spotProblem = stitchFields
      ? placementError(selectedOption, placement)
      : "";
    if (spotProblem) {
      setStitchError(spotProblem);
      return;
    }
    setStitchError(null);

    if ((selectedTask, selectedOption)) {
      // One mark on every row this trip adds, so the screens after this one
      // (the repair's location, the alteration's method, the notes to the
      // tailors) write themselves onto all of them and not just the first.
      const batch = `add-${Date.now()}`;
      sessionStorage.setItem("addedBatch", batch);
      const added = [
        ...(cartItems[0]?.services || []).map((item) => {
          if (
            item.selectedTask === storedTask &&
            item.selectedOption === storedOption
          ) {
            return {
              ...item,
              selectedOption: selectedOption,
              selectedService: selectedTask,
              item_details: JSON.parse(sessionStorage.getItem("selectedItems")),
            };
          }
          return item;
        }),
        ...((cartItems[0]?.services || []).findIndex(
          (item) =>
            item.selectedTask === storedTask &&
            item.selectedOption === storedOption,
        ) === -1
          ? services.flatMap((item) =>
              Array.from({ length: countToAdd }, () => ({
                ...item,
                selectedOption: selectedOption,
                selectedService: selectedTask,
                item_details: JSON.parse(
                  sessionStorage.getItem("selectedItems"),
                ),
                added_batch: batch,
                // Where it goes, asked here because it is the same decision
                // as whether the garment has to be opened up. The screen
                // after this one adds the design and the thread to the same
                // record (utils/chainstitch.js).
                ...(placementDetails(selectedOption, placement)
                  ? {
                      chainstitch_details: placementDetails(
                        selectedOption,
                        placement,
                      ),
                    }
                  : {}),
                // What this service would cost as the first of its kind and
                // as one after it, so the cart can re-tier itself when a row
                // is removed without going back to the catalogue.
                pair: pairSiblings(item, data, itemName),
              })),
            )
          : []),
      ];
      // Same rule the × buttons already use (utils/cartSummary.js): on a
      // service that has a first-one and an each-extra price, the first row
      // of that family on this piece is the first-one price and the rows
      // after it are each-extra. A service with no such pair, a button or a
      // custom line, repeats at its own price.
      // Opening the garment up is its own catalogue line, added here as one
      // rather than written into a note. It is never picked from the list
      // (#936), so this tick box is the only way it can reach an order, and
      // unticking it takes the row back off.
      const piece = JSON.parse(sessionStorage.getItem("selectedItems"));
      const samePiece = (one, other) =>
        one !== undefined && one !== null && String(one) === String(other);
      const isPocketRow = (service) =>
        service?.name === POCKET_OR_SEAM &&
        samePiece(piece?.id, service?.item_details?.id);
      const withoutPocket = added.filter((service) => !isPocketRow(service));
      const withPocket =
        openIt && pocketLine
          ? [
              ...withoutPocket,
              {
                ...pocketLine,
                selectedOption: pocketLine.name,
                selectedService: "Chainstitch",
                item_details: piece,
              },
            ]
          : withoutPocket;
      updateCartItem(cartItems[0].id, {
        services: repricePairs({
          itemsData: cartItems[0]?.itemsData,
          services: withPocket,
        }).services,
      });
      if (selectedTask === "Alteration") {
        sessionStorage.setItem("task", selectedTask);
        sessionStorage.setItem("option", selectedOption);
        sessionStorage.setItem("optionprice", selectedOptionPrice);
        sessionStorage.setItem("pinVideo", pinVideo);
        navigate("/perfect-fit", {
          state: { selectedTask, selectedOption, data: location.state },
        });
      } else {
        // Repairs and washes both go to know-more. A repair gets its location
        // and description fields there; a wash falls through to the general
        // "anything else we should know" notes, which is the right place for
        // "cold water only".
        sessionStorage.setItem("task", selectedTask);
        sessionStorage.setItem("option", selectedOption);
        sessionStorage.setItem("pinVideo", pinVideo);
        sessionStorage.setItem("optionprice", selectedOptionPrice);
        navigate("/know-more", {
          state: { selectedTask, selectedOption, data: location.state },
        });
      }
    }
  };

  // Coming back to change the line that was just picked: it is taken out of
  // the basket so picking again cannot add it twice.
  //
  // The $30 for opening the garment up goes with it, and so does the spot,
  // both of which come straight back when the line is picked again. They
  // belong to that line and to nothing else, so leaving the $30 behind left
  // a basket with an opened seam and nothing stitched in it, which is what
  // Calley hit on 31 Oct 2026: "it removes the chainstitch price and just
  // does the 30 open."
  useEffect(() => {
    const option = sessionStorage.getItem("option");
    const rows = cartItems[0]?.services || [];
    let piece = null;
    try {
      piece = JSON.parse(sessionStorage.getItem("selectedItems"));
    } catch {
      piece = null;
    }
    const onThisPiece = (service) =>
      piece?.id !== undefined &&
      piece?.id !== null &&
      String(piece.id) === String(service?.item_details?.id);
    const rePickingStitch = Boolean(chainstitchFields(option)?.placement);
    const itsPocketRow = (service) =>
      rePickingStitch &&
      service?.name === POCKET_OR_SEAM &&
      onThisPiece(service);

    if (rePickingStitch) {
      const was = rows.find(
        (service) => service?.name === option && onThisPiece(service),
      );
      const spot = was?.chainstitch_details?.placement;
      if (spot) setPlacement(spot);
      if (rows.some(itsPocketRow)) setOpenIt(true);
    }

    const filteredServices = rows.filter(
      (service) => service?.name != option && !itsPocketRow(service),
    );
    updateCartItem(cartItems[0].id, {
      services: filteredServices,
    });
  }, []);
  useEffect(() => {
    if (location?.state?.addNewService) {
      setselectedPricingPlan(location?.state?.selectedItem?.description);
    }
    setselectedPricingPlan(cartItems[0]?.pricing_plan);
  }, [cartItems]);

  // For the option list (utils/serviceOptions.js): which garment this is,
  // and what's already in the basket for it — an "ADDITIONAL" hole needs a
  // first hole for the same garment.
  const itemName = location?.state?.selectedItem?.name || selectedType || "";
  const itemId = (() => {
    try {
      return JSON.parse(sessionStorage.getItem("selectedItems"))?.id;
    } catch {
      return undefined;
    }
  })();
  // What this trip is about to put on the bill, so the basket on the left
  // answers "four of what, and for how much?" while the count is still being
  // set, instead of only once the screen is left. The prices come back from
  // the cart's own re-tiering (utils/cartSummary.js): on a first-one and
  // each-extra family, four is not four times the price on the chip.
  const plan =
    sessionStorage.getItem("SelectedPlan") === "Premium" ||
    location?.state?.selectedItem?.pricing_plan === "Premium"
      ? "Premium"
      : "Standard";
  // The $30 for opening the garment up, on the plan this piece is on.
  const openItPrice =
    plan === "Premium" ? pocketLine?.premium_price : pocketLine?.standard_price;
  const rowPrices =
    pickedService && selectedOption
      ? addedPrices(
          cartItems?.[0],
          {
            ...pickedService,
            item_details: { id: itemId, name: itemName },
            pair: pairSiblings(pickedService, data, itemName),
          },
          countToAdd,
          plan,
        )
      : [];
  const addedMoney = rowPrices.length
    ? rowPrices.reduce((sum, price) => sum + price, 0)
    : Number(selectedOptionPrice) || 0;
  const money = (amount) =>
    `$${Number.isInteger(amount) ? amount : Number(amount).toFixed(2)}`;
  // Only worth a line when the rows don't all cost the same, which is the
  // case the total looks wrong in.
  const countNote = (() => {
    if (countToAdd < 2 || rowPrices.length !== countToAdd) return "";
    const [first, ...rest] = rowPrices;
    if (rest.every((price) => price === first)) {
      return `${countToAdd} at ${money(first)} each`;
    }
    if (rest.every((price) => price === rest[0])) {
      return `${money(first)}, then ${rest.length} at ${money(rest[0])}`;
    }
    return "";
  })();

  const lockContext = {
    itemName,
    itemId,
    basketServices: cartItems?.[0]?.services,
    // The garment's whole list, so a lock can name the option it wants.
    services,
  };

  const renderServiceItem = (item, index, pricingPlan) => {
    if (
      (item?.is_premium && pricingPlan === "Premium") ||
      (item?.is_standard && pricingPlan === "Standard")
    ) {
      return (
        <li key={item?._id || index}>
          <button
            onClick={() => handleOptionSelection(item, item)}
            disabled={Boolean(lockedReason(item, lockContext))}
            title={lockedReason(item, lockContext) || undefined}
            className={
              selectedOption === item?.name
                ? "item-selected"
                : lockedReason(item, lockContext)
                  ? "service-locked"
                  : ""
            }
          >
            {/* The garment is already chosen, so "JUMPSUIT - " is dropped
                from the button. The saved service name is unchanged. */}
            {shortServiceName(item?.name, itemName)}
          </button>
        </li>
      );
    }
    return null;
  };

  const renderServices = (services) => {
    return services?.map((item, index) => {
      let pricingPlan = location?.state?.addNewService
        ? location?.state?.selectedItem?.pricing_plan
        : location?.state?.selectedPlan;
      pricingPlan = pricingPlan || sessionStorage.getItem("SelectedPlan");
      if (TASK_FOR_KIND[serviceKind(item)] === selectedTask) {
        return renderServiceItem(item, index, pricingPlan);
      }
      return null;
    });
  };

  // Why some visible options are greyed out, said once each. "Visible" is
  // the same test renderServiceItem and renderServices apply: offered on the
  // chosen plan, and of the chosen kind (alteration or repair).
  const lockNotes = (services) => {
    if (!selectedTask) return [];
    const pricingPlan =
      (location?.state?.addNewService
        ? location?.state?.selectedItem?.pricing_plan
        : location?.state?.selectedPlan) ||
      sessionStorage.getItem("SelectedPlan");
    const shown = (services || []).filter(
      (item) =>
        ((item?.is_premium && pricingPlan === "Premium") ||
          (item?.is_standard && pricingPlan === "Standard")) &&
        TASK_FOR_KIND[serviceKind(item)] === selectedTask,
    );
    return [
      ...new Set(
        shown.map((item) => lockedReason(item, lockContext)).filter(Boolean),
      ),
    ];
  };

  const selectedItem =
    location?.state?.selectedItem || sessionStorage.getItem("selectedItem");

  return (
    <section className="items-section same-bg-section relative">
      <div className="container padding-x-all">
        <div className="alteration-box items-box sec-com-padding flex-box justify-between align-center">
          {/* What's being picked on this screen, above the running basket. */}
          {[
            { className: "mobile-none", open: !isOpen },
            { className: "desktop-none", open: !isOpen1 },
          ].map((box) => (
            <CartSummary
              key={box.className}
              className={box.className}
              isOpen={box.open}
              onToggle={toggleBox}
            >
              <div className="show-box-list">
                <p className="show-box-para">This item</p>
                <h4 className="show-box-answer">{selectedType}</h4>
              </div>

              <div className="show-box-list">
                <p className="show-box-para">Plan</p>
                <h4 className="show-box-answer">
                  {location?.state?.addNewService
                    ? location?.state?.selectedItem?.pricing_plan
                    : sessionStorage.getItem("SelectedPlan")}
                </h4>
              </div>

              <div className="show-box-last-list">
                <p className="show-box-para">Task Detail</p>
                <h4 className="show-box-answer">{selectedTask || "-"}</h4>
                <div className="service-job-detail-box">
                  <p className="show-box-para">
                    {selectedOption || "-"}
                    {countToAdd > 1 ? ` × ${countToAdd}` : ""}
                  </p>
                  {selectedOptionPrice != "" && (
                    <div className="text-box">
                      <h4 className="show-box-answer">{money(addedMoney)}</h4>
                    </div>
                  )}
                </div>
                {countNote && <p className="show-box-para">{countNote}</p>}
              </div>
            </CartSummary>
          ))}

          <div className="item-select-box">
            <h2>
              Would you like your {selectedType ? selectedType : "item"}{" "}
              altered, repaired or washed?
            </h2>
            <p className="para">
              Select one service, if you require another you can add this at a
              later stage.
            </p>

            <div className="alteration-select-box wears-box flex-box justify-between">
              <div className="icon-main-box">
                <button
                  onClick={() => handleTaskSelection("Alteration")}
                  className={
                    selectedTask === "Alteration"
                      ? "icon-box item-selected"
                      : "icon-box"
                  }
                >
                  <img src={alterationIconOne} alt="" />
                  <h6>Altered</h6>
                </button>
                <button
                  onClick={() => handleTaskSelection("Repairing")}
                  className={
                    selectedTask === "Repairing"
                      ? "icon-box item-selected"
                      : "icon-box"
                  }
                >
                  <img src={alterationIconTwo} alt="" />
                  <h6>Repair</h6>
                </button>
                {/* A wash is an add-on: the options inside are locked until
                    this garment has an alteration or repair in the basket
                    (utils/serviceOptions.js). */}
                <button
                  onClick={() => handleTaskSelection("Wash")}
                  className={
                    selectedTask === "Wash"
                      ? "icon-box item-selected"
                      : "icon-box"
                  }
                >
                  <img src={washIcon} alt="" />
                  <h6>Wash</h6>
                </button>
                {/* Counter only: these services are `studio_only`, so this
                    button is in fxrypopup and not in fxryshop. Not an add-on
                    like a wash — a jacket may come in for a name and nothing
                    else, so nothing here is locked.

                    This used to borrow the repair icon, there being no
                    chainstitch artwork, which left two of the four buttons
                    showing the same picture. The one wearing the borrowed
                    picture is also the only one with the word "stitch" in it,
                    which sits next to a service called FIX STITCHING. A repair
                    was rung up as chainstitch that way on 30 Oct 2026. It has
                    its own icon now: a run of chain stitch, which is the one
                    thing on this screen the repair icon cannot also be. */}
                <button
                  onClick={() => handleTaskSelection("Chainstitch")}
                  className={
                    selectedTask === "Chainstitch"
                      ? "icon-box item-selected"
                      : "icon-box"
                  }
                >
                  <img src={chainstitchIcon} alt="" />
                  <h6>Chainstitch</h6>
                </button>
              </div>
              <div className="text-box">
                {!isLoading && (
                  <>
                    {selectedTask != "" && (
                      <p className="para">Select option...</p>
                    )}
                    {/* Every option at once, related ones together, most
                        booked first (utils/serviceOptions.js). The
                        chainstitch pocket-or-seam line is left out: it is an
                        add-on offered on the next screen, not a service
                        anyone picks (utils/chainstitch.js). */}
                    <ul className="items-wears-listing service-options">
                      {renderServices(
                        pickableServices(orderServices(data, itemName)),
                      )}
                    </ul>
                    {/* How many of this one go on the garment. Only on the
                        services that really repeat, and sitting right under
                        the options so it reads as part of the pick. Back to 1
                        every time the pick changes, so a count can never ride
                        along onto the next service by accident. */}
                    {canRepeat && (
                      <div className="service-count">
                        <span className="service-count__label">How many?</span>
                        <span className="service-count__stepper">
                          <button
                            type="button"
                            aria-label="One fewer"
                            disabled={howMany <= 1}
                            onClick={() => setHowMany(Math.max(1, howMany - 1))}
                          >
                            −
                          </button>
                          <span
                            className="service-count__number"
                            aria-live="polite"
                          >
                            {howMany}
                          </span>
                          <button
                            type="button"
                            aria-label="One more"
                            disabled={howMany >= MOST}
                            onClick={() =>
                              setHowMany(Math.min(MOST, howMany + 1))
                            }
                          >
                            +
                          </button>
                        </span>
                        {howMany > 1 && (
                          <span className="service-count__note">
                            {howMany} lines on the bill
                          </span>
                        )}
                      </div>
                    )}
                    {/* Chainstitch, with the garment in hand: where it
                        goes, and whether we have to open it up to get at
                        that spot. One decision, so one place to answer it,
                        and the $30 the second one costs is read off the
                        catalogue. What is being stitched is asked on the
                        next screen. */}
                    {stitchFields?.placement && (
                      <div className="stitch-spot">
                        <div className="field-box">
                          <label
                            className="label-on-line"
                            htmlFor="stitch-spot"
                          >
                            Where on the garment
                          </label>
                          <input
                            id="stitch-spot"
                            type="text"
                            placeholder="e.g. left chest, above the back pocket"
                            maxLength={MAX_PLACEMENT}
                            value={placement}
                            onChange={(e) => {
                              setPlacement(e.target.value);
                              if (stitchError) setStitchError(null);
                            }}
                          />
                          <p className="para stitch-hint">
                            Pin the spot with them before the garment goes on
                            the rack.
                          </p>
                        </div>
                        {pocketLine && (
                          <label className="stitch-add">
                            <input
                              type="checkbox"
                              checked={openIt}
                              onChange={(e) => setOpenIt(e.target.checked)}
                            />
                            <span>
                              We have to open it up: take the pocket off or open
                              the seam, then put it back
                              {openItPrice ? (
                                <strong> ${openItPrice}</strong>
                              ) : null}
                            </span>
                          </label>
                        )}
                        {stitchError && (
                          <p className="para stitch-error">{stitchError}</p>
                        )}
                      </div>
                    )}
                    {lockNotes(pickableServices(data)).map((note) => (
                      <p key={note} className="para service-locked-note">
                        {note}
                      </p>
                    ))}
                    {selectedTask != "" && selectedTask !== "Wash" && (
                      <div
                        className="custom-option-box"
                        style={{
                          marginTop: "1rem",
                          paddingTop: "1rem",
                          borderTop: "1px solid #e0e0e0",
                        }}
                      >
                        <p className="para" style={{ marginBottom: "0.5rem" }}>
                          Not on the list? Write it in:
                        </p>
                        <div className="field-box">
                          <label className="label-on-line">
                            {{
                              Alteration: "Custom alteration",
                              Chainstitch: "Custom chainstitch",
                            }[selectedTask] || "Custom repair"}
                          </label>
                          <input
                            type="text"
                            placeholder={
                              {
                                Alteration: "e.g. Take in the bust",
                                // Custom chainstitch is quoted, not on the
                                // sheet, and starts at $150 paid up front
                                // (Calley). Taken case by case.
                                Chainstitch:
                                  "e.g. Drawn design, back of jacket",
                              }[selectedTask] || "e.g. Reinforce inner seam"
                            }
                            value={customDescription}
                            onChange={(e) =>
                              setCustomDescription(e.target.value)
                            }
                          />
                        </div>
                        <div className="field-box">
                          <label className="label-on-line">Price ($)</label>
                          <input
                            type="number"
                            min="0"
                            step="0.01"
                            placeholder="e.g. 230"
                            value={customPrice}
                            onChange={(e) => setCustomPrice(e.target.value)}
                          />
                        </div>
                        <div className="field-box">
                          <label className="label-on-line">
                            Time guess, minutes (just for us)
                          </label>
                          <input
                            type="number"
                            min="0"
                            step="5"
                            inputMode="numeric"
                            placeholder="e.g. 90"
                            value={customMinutes}
                            onChange={(e) => setCustomMinutes(e.target.value)}
                          />
                        </div>
                        <button
                          type="button"
                          className={
                            selectedOption &&
                            selectedOption === customDescription.trim() &&
                            customDescription.trim() !== ""
                              ? "save-alteration-btn item-selected"
                              : "save-alteration-btn"
                          }
                          onClick={handleCustomSubmit}
                          disabled={
                            !customDescription.trim() ||
                            !customPrice ||
                            parseFloat(customPrice) <= 0
                          }
                          style={{ marginTop: "0.5rem" }}
                        >
                          Save this{" "}
                          {selectedTask === "Alteration"
                            ? "alteration"
                            : "repair"}
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <button
              className={`${
                selectedTask && selectedOption
                  ? "section-main-btn"
                  : "section-main-btn1"
              }`}
              type="button"
              disabled={selectedTask && selectedOption ? false : true}
              onClick={handleApply}
            >
              {" "}
              Fix/Fit it
              <span>
                <img src={btnArrow} alt="" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Alteration;
